(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-home-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pb-product-hover')) {
  customElements.define('pb-product-hover', class extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template[data-pb-hover-image]');
      if (!this.template || this.image) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.hoverMedia = matchMedia('(any-hover: hover) and (any-pointer: fine)');
      const observe = () => {
        this.observer?.disconnect();
        if (!this.hoverMedia.matches || this.image) return;
        if (!('IntersectionObserver' in window)) return this.loadImage();
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadImage();
        }, { rootMargin: '250px' });
        this.observer.observe(this);
      };
      this.hoverMedia.addEventListener('change', observe, options);
      this.closest('a')?.addEventListener('focusin', event => {
        if (event.currentTarget.matches(':focus-visible')) this.loadImage();
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.loadImage();
      }, options);
      observe();
    }
    loadImage() {
      if (this.image || !this.template) return;
      this.observer?.disconnect();
      this.image = this.template.content.querySelector('img').cloneNode(true);
      this.image.addEventListener('load', () => {
        if (this.image.naturalWidth) this.setAttribute('data-secondary-ready', '');
      }, { once: true });
      this.append(this.image);
      if (this.image.complete && this.image.naturalWidth) this.setAttribute('data-secondary-ready', '');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-refined-header-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const attachHeaderSizing = () => {
    const header = document.querySelector('#shopify-section-header .header-wrapper');
    if (!header || !header.querySelector('.pb-refined-header') || header.dataset.pbSizing) return;
    header.dataset.pbSizing = 'true';
    const announcement = document.querySelector('.announcement-bar-section');
    const root = document.documentElement;
    const update = () => {
      const announcementHeight = announcement?.querySelector('.utility-bar:not(.hidden)') ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
      const headerHeight = Math.ceil(header.getBoundingClientRect().height);
      root.style.setProperty('--pb-refined-announcement-height', `${announcementHeight}px`);
      root.style.setProperty('--pb-refined-header-box', `${headerHeight}px`);
      root.style.setProperty('--header-height', `${announcementHeight + headerHeight}px`);
      root.style.setProperty('--pb-home-header-height', `${announcementHeight + headerHeight}px`);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    if (announcement) observer.observe(announcement);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(header)) observer.disconnect();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachHeaderSizing, { once:true });
  else attachHeaderSizing();
  document.addEventListener('shopify:section:load', attachHeaderSizing);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-refined-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pb-refined-rating')) {
  customElements.define('pb-refined-rating', class extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('.pb-refined-rating__source');
      if (!this.source) return;
      this.refresh = () => this.updateRating();
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.source, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-reviews', 'data-rating']
      });
      document.addEventListener('stamped:badges:loaded', this.refresh);
      this.updateRating();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('stamped:badges:loaded', this.refresh);
    }
    updateRating() {
      const caption = this.source.querySelector('.stamped-badge-caption[data-reviews]');
      const count = Number(caption?.getAttribute('data-reviews'));
      const rating = Number(caption?.getAttribute('data-rating'));
      const valid = Number.isInteger(count) && count > 0 &&
        Number.isFinite(rating) && rating > 0 && rating <= 5;
      if (!valid) {
        this.hidden = true;
        this.removeAttribute('aria-label');
        this.querySelector('[data-pb-rating-value]').textContent = '';
        this.querySelector('[data-pb-rating-count]').textContent = '';
        return;
      }
      const displayRating = rating.toFixed(1);
      const displayCount = count.toLocaleString(document.documentElement.lang || 'en');
      this.querySelector('[data-pb-rating-value]').textContent = displayRating;
      this.querySelector('[data-pb-rating-count]').textContent = '(' + displayCount + ')';
      this.setAttribute('aria-label', this.dataset.ratingLabel
        .replace('__rating__', displayRating).replace('__count__', displayCount));
      this.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
